import { render, staticRenderFns } from "./CommentAdmin.vue?vue&type=template&id=289f1cc8&"
import script from "./CommentAdmin.vue?vue&type=script&lang=js&"
export * from "./CommentAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CommentAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommentAdmin.vue"
export default component.exports